export default __webpack_public_path__ + "fonts/montserrat700.woff2";